/* unplugin-vue-components disabled */import script from "./LayoutHead.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutHead.vue?vue&type=script&setup=true&lang=js"

import "./LayoutHead.vue?vue&type=style&index=0&id=375afea6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\zyark\\Desktop\\ems-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-375afea6"]])

export default __exports__